import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Home from "./Home";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Gallery from "./components/pages/gallery/Gallery";
import Contact from "./components/pages/contact/Contact";

const router = createBrowserRouter([
	{
		path: "/",
		element: <Home />,
	},
	{
		path: "gallery",
		element: <Gallery />,
	},
	{
		path: "contact",
		element: <Contact />,
	},
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);
